/** What the bottom-right "+" does on each page: the page's own kind of thing,
 *  and nothing on a page with nothing to add. One table, so every route is
 *  decided here and tested here (see DESIGN.md, Floating buttons). */
export type FabAction =
  | { kind: "link"; label: string; href: string }
  | { kind: "new-design"; label: string }
  | { kind: "new-outfit"; label: string };

const NEW_DESIGN: FabAction = { kind: "new-design", label: "New design" };
const NEW_OUTFIT: FabAction = { kind: "new-outfit", label: "New outfit" };
const CLOTHES: FabAction = { kind: "link", label: "Clothes", href: "/capture?kind=clothes" };
const SWATCH: FabAction = { kind: "link", label: "Swatch", href: "/capture?kind=swatch" };
const INSPIRATION: FabAction = { kind: "link", label: "Inspiration", href: "/capture?kind=inspiration" };
const CAPTURE: FabAction = { kind: "link", label: "Capture", href: "/capture" };

const under = (path: string, root: string) => path === root || path.startsWith(`${root}/`);

export function fabFor(pathname: string): FabAction | null {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  if (path === "/" || path === "/designs") return NEW_DESIGN;
  // The Studio adds fabric; its Sew and gift pages have nothing to add.
  if (/^\/designs\/[^/]+$/.test(path)) return SWATCH;
  if (under(path, "/designs")) return null;
  if (under(path, "/swatches")) return SWATCH;
  if (under(path, "/inspiration")) return INSPIRATION;
  // The Outfits tab adds an outfit; a board has nothing to add (its drawer adds pieces); the rest of the Closet adds clothes.
  if (path === "/closet/outfits") return NEW_OUTFIT;
  if (under(path, "/closet/outfits")) return null;
  // A Passage trip's page picks existing outfits; it has nothing to add.
  if (under(path, "/closet/trips")) return null;
  if (under(path, "/closet")) return CLOTHES;
  // /capture and /inbox/add are the forms themselves; settings, stats and feedback have nothing to add.
  if (under(path, "/capture") || path === "/inbox/add" || under(path, "/settings") || under(path, "/feedback") || under(path, "/stats")) return null;
  return CAPTURE; // the Inbox, and any page added later until it says otherwise
}
